import React, { useEffect, useState  , useMemo} from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setPerformanceChildAction,
  setPerformanceDeleteAction,
  setSelectedPerformer,
} from "../../../Redux/Slice";
import { NavLink } from "react-router-dom";
import ReactTable from "../../AppComponent/Table";
import "../../../StyleSheet/MainComponent/Performance/Performance.scss";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";


const PerformanceChildTable = (props) => {
  const { performanceData, setEditPayload, setDeleteID, setDeletepopup } =
    props;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [newpages, setNewpage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [search, setsearch] = useState("");
  const [pageSize, setPageSize] = useState(20);
  const MakeCreate = true;

  const state = useSelector((state) => state);

  const performanceDataTotalCount = useSelector(
    (state) => state.performanceChildTypeCall.Total_Count
  );
  //  console.log(state.performanceTypeCall.selectedPerformerData.id , "performanceTypeCall");
  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    setdtPageindex(arg);
  };
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        const payload = {
          search: e,
          page_size: dtpagesize,
          page: 1,
          id: state.performanceTypeCall.selectedPerformerData.id,
        };
        dispatch(setPerformanceChildAction(payload));
      }, 500),
    []
  );

  // -----Search------------------------
  function tochange(e) {
    setsearch(e);
    setdtPageindex(1);
    props.searchchanges(e);
    debouncedSearch(e);

    // if (e.trim() != undefined && e.trim() != "") {
    //   const payload = {
    //     search: e.trim(),
    //     page_size: dtpagesize,
    //     page: 1,
    //     id: state.performanceTypeCall.selectedPerformerData.id,
    //   };
    //   dispatch(setPerformanceChildAction(payload));
    // }
    // if (e == "" || search == "") {
    //   const payload = {
    //     search: "",
    //     page_size: dtpagesize,
    //     page: 1,
    //     id: state.performanceTypeCall.selectedPerformerData.id,
    //   };
    //   dispatch(setPerformanceChildAction(payload));
    // }
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  useEffect(() => {
    const payload = {
      search: "",
      page_size: 10,
      page: dtpageindex,
      id: state.performanceTypeCall.selectedPerformerData.id,
    };
    dispatch(setPerformanceChildAction(payload));
  }, [dtpageindex]);


  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};

  const columns = [
    {
      Header: "Name",
      accessor: "",
      Cell: (row) => {
        return <div>{row.row.original.grading_name}</div>;
      },
    },

    {
      Header: "Description",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.description != null &&
            row.row.original.description != undefined ? (
              <div>{row.row.original.description}</div>
            ) : null}
          </>
        );
      },
    },

    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <div>
            <span>
              {`${
                row.row.original.created_at.slice(0, 10) + "  " + formattedTime
              }`}
            </span>
          </div>
        );
      },
    },
    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              <button
                className=" btn Status"
                onClick={(e) => {
                  setEditPayload(row.row.original);
                }}
                component="span"
              >
                              <span className="OuterActionSpan">
                  <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                  <span className="ActionsList"> Edit </span>
                </span>
              </button>

              <button
                type="button"
                class="btn Status"
                onClick={() => {
                  setDeleteID(row.row.original.id);
                  setDeletepopup(true);
                  props.dtpageindex(dtpageindex);
                }}
              >
               <span className="OuterActionSpan">
                   <span  className="EditImages">
                    <img src={DeleteImages}/>
                  </span>

                  <span className="ActionsList"> Delete </span>
                </span>
              </button>
            </div>
          </>
        );
      },
    },
  ];

  const ViewFunctions = (data) => {
    // console.log(data, "mulamulamula");
    // setDeleteID(data.id);
    // dispatch(setSelectedPerformer(data));
    // navigate("/performance_child");
  };
  return (
    <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
      <ReactTable
        data={performanceData}
        columns={columns}
        totalItems={performanceDataTotalCount}
        currentPage={dtpageindex}
        onChange={tochange}
        setCurrentPage={setCurrentPage}
        pagesize={pagesize}
        onPrevious={handlePrevious}
        onNextpage={handleNext}
        GotoEnteredPage={GotoEnteredPage}
  dtpagesize={pageSize}
        dtpageindex={dtpageindex}
        pageindex={pageindex}
        datacount={performanceDataTotalCount}
        
        // MakeCreate={MakeCreate}
        // ViewParts={(e) => {
        //   ViewFunctions(e);
        // }}

        Filter={true}
        NoFilter ={true}


      />
    </div>
  );
};

export default PerformanceChildTable;
